import EventService from '../react-components/CalculationComponents/calculationComponents.eventservice';
import { setFocusOnElementById } from 'sos-common/js/utils/helpers';

const STEP_CLASS_NAME = 'stb-form-step';

/**
 * Contains goToStep method to navigate between steps.
 */
class StepService {
  private static instance: StepService;

  private constructor() {}

  public static getInstance = ():StepService =>  {
    if (!StepService.instance) StepService.instance = new StepService();
    return StepService.instance;
  }

  /**
   * Set the correct CSS classes to the steps and fire a 'step-changed' event.
   */
  public goToStep = (step: number) => {
    let htmlCollection = document.getElementsByClassName(STEP_CLASS_NAME);

    // remove current active class, add new active class
    let i = 0;
    [].forEach.call(htmlCollection, (element:Element) => {
        element.classList.remove('active');
        if (i === step) element.classList.add('active');
        i++;
    });
    EventService.fire('step-changed', { detail: step });

    setFocusOnElementById("step" + (step +1));
    var mainElement = document.getElementsByTagName('main')[0];
    if (mainElement) mainElement.scrollIntoView({behavior: 'smooth'});
  };
}

export default StepService.getInstance();
